var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgDeezerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.9 24.5",
    width: 2500,
    height: 1306,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#b1e3fa}.st1{fill:#f7bacf}.st2{fill:#e7ee9f}.st3{fill:#feea3a}.st4{fill:#fe9d7f}.st5{fill:#4ec2f6}.st6{fill:#ccdb38}.st7{fill:#fe3f80}.st8{fill:#fe3d02}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path59",
    className: "st0",
    d: "M38.3 13.9v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.3v-1h8.6v2.1h-8.6V4.2zm0-3.1V0h8.6v2.2h-8.6V1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path57",
    className: "st1",
    d: "M19.1 13.9v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1zm0-3.3v-1h8.6v2.1h-8.6V4.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path55",
    className: "st2",
    d: "M28.7 13.9v-1h8.6v2h-8.6v-1zm0-3.2v-1h8.6v2h-8.6v-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path53",
    className: "st3",
    d: "M9.6 23.5v-1H18v2H9.6v-1zm0-3.3v-1H18v2H9.6v-1zm0-3.2v-1H18v2H9.6v-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path51",
    className: "st4",
    d: "M0 13.9v-1h8.4v2H0v-1zm0-3.2v-1h8.4v2H0v-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path49",
    className: "st5",
    d: "M38.4 23.5v-1h8.4v2h-8.4v-1zm0-3.3v-1h8.4v2h-8.4v-1zm0-3.2v-1h8.4v2h-8.4v-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path47",
    className: "st6",
    d: "M28.8 23.5v-1h8.4v2h-8.4v-1zm0-3.3v-1h8.4v2h-8.4v-1zm0-3.2v-1h8.4v2h-8.4v-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path45",
    className: "st7",
    d: "M19.2 23.5v-1h8.4v2h-8.4v-1zm0-3.3v-1h8.4v2h-8.4v-1zm0-3.2v-1h8.4v2h-8.4v-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path43",
    className: "st8",
    d: "M0 23.5v-1h8.4v2H0v-1zm0-3.3v-1h8.4v2H0v-1zM0 17v-1h8.4v2H0v-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeezerIcon);
export default __webpack_public_path__ + "static/media/img-deezer-icon.a1407265907e6b7b810032960a567d40.svg";
export { ForwardRef as ReactComponent };